import { Typography } from '@mui/material'
import React from 'react'

export default function CustomLargeLabel({ required = false, value, fontWeight, marginTop, variantType, limitWidth, ...props }) {
    return (
        <Typography variant={variantType ? variantType : 'h4'} fontWeight={fontWeight} component={'p'} mb={1} mt={marginTop ? marginTop : 2} style={limitWidth ? { width: '90%' } : {}}>{`${value}`}{required ? <Typography variant={variantType ? variantType : 'h3'} component={'span'} color={'red'} ml={.5} >{`*`}</Typography> : ''}</Typography>
    )
}
